<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "Providers"
};
</script>

<style scoped>
</style>
